import React, { useEffect } from 'react';
import Settings from '../../../Settings/Settings'
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Style from './Styles/CompatibleProductComponentStyle';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import LoadingComponent from '../../LoadingComponent/LoadingComponent';
import DeleteIcon from '@mui/icons-material/Delete';

export default function AddCompatibleProductProduct(props) {
    const classes = Style();

    const [searchProducts, setSearchProducts] = React.useState("")
    const [productsRestuls, setProductsResults] = React.useState([])
    const [compatibleProducts, setCompatibleProducts] = React.useState([])
    const [loadingProducts, setLoadingProducts] = React.useState(false)
    useEffect(() => {
        getCompatibleProductsProduct()
        }, []);
    const componentConstants = {
        ...props.componentConstants
      }
    
      const componentMethods = {
          ...props.componentMethods
      }
    
      const componentProps = {
          ...props.componentProps
      }

      const postCompatibleProductsProduct = (productsID) => {
        let method = "POST"
        let url = Settings.API_URL + Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS_PRODUCT
        let requestObject = {
            shopCompatibleProductsShopProductsShopCompatibleProductsID: props.shopCompatibleProductsID,
            shopCompatibleProductsShopProductsShopProductsID: productsID
        }
        let accountToken = ''
        if(componentMethods.getLocalStorage('user') && componentMethods.getLocalStorage('user').tokensHash) {
            accountToken = '?accountToken=' + componentMethods.getLocalStorage('user').tokensHash
        }

        componentMethods.ajax(url += accountToken, 
            requestObject, 
            method, null, 
            (data) => {
                componentMethods.addError(componentConstants.language.LANG_SUCCESSFULY_SAVED_COMPATIBLE_PRODUCT);
                getCompatibleProductsProduct()
            },
            {}, 
            true, (data) => {
            componentMethods.addError(componentConstants.language.LANG_COULD_NOT_SAVE_COMPATIBLE_PRODUCT);
            getCompatibleProductsProduct()
        }, (data) => {
            componentMethods.addError(componentConstants.language.LANG_COULD_NOT_SAVE_COMPATIBLE_PRODUCT);
            getCompatibleProductsProduct()
        })
      }
        const getCompatibleProductsProduct = () => {
            let endpoint = Settings.API_ENDPOINT_COMPATIBLE_PRODUCTS + '/' + props.shopCompatibleProductsID

            componentMethods.ajax(Settings.API_URL + endpoint,{},"GET", null, (data) => {
                setCompatibleProducts(data.items)
            })
        }
      const searchProductsAction = () => {
        let method = "GET"
        let url = Settings.API_URL + Settings.API_ENDPOINT_PRODUCTS + "?q=" + searchProducts
        setLoadingProducts(true)
        componentMethods.ajax(url, 
            {}, 
            method, null, 
            (data) => {
                setProductsResults(data.items)
                setLoadingProducts(false)
            })
      }
  return (<div style={classes.rootAddress}><React.Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12} lg={12}>
                    <TextField fullWidth={true} value={searchProducts} onChange={(e)=> {setSearchProducts(e.target.value)}}  label={componentConstants.language.LANG_COMPATIBLE_PRODUCTS_SEARCH_PRODUCT} />
                    <Button color="secondary" onClick={searchProductsAction} fullWidth component="div" variant="contained" startIcon={<AccountTreeIcon />}>
                        {componentConstants.language.LANG_COMPATIBLE_PRODUCTS_SEARCH_PRODUCT}
                    </Button>
                </Grid>
                {
                productsRestuls.length === 0 ?
                    <Grid item xs={12} md={12} lg={12}>
                        <Typography>{componentConstants.language.LANG_EMPTY_RESULTSET}</Typography>
                    </Grid>
                :
                    null
                }
                {
                    loadingProducts ?
                    <Grid item xs={12} md={12} lg={12}>
                        <LoadingComponent />
                    </Grid>
                :
                    null
                }
                {productsRestuls.map((item, index)=> {
                    return <Grid item xs={12} md={12} lg={6} key={index}>
                        <Button color="secondary" onClick={() => {postCompatibleProductsProduct(item.shopProductsID)}} fullWidth component="div" variant="contained" startIcon={<AccountTreeIcon />}>
                            {item.shopProductsArticleId} {item.shopProductsArticleName} {item.shopProductsBrand} {item.shopProductsOemCode}
                        </Button>
                    </Grid>
                })}
                {compatibleProducts.map((item, index)=> {
                    return <Grid item xs={12} md={12} lg={6} key={index}>
                                {item.shopProductsArticleId} {item.shopProductsArticleName} {item.shopProductsBrand} {item.shopProductsOemCode}
                                <IconButton onClick={(e) => {componentMethods.setOpenDeleteCompatibleProductsProduct(true, item.shopCompatibleProductsShopProductsID)}}><DeleteIcon /></IconButton>
                            </Grid>
                })}
        </Grid>
    </React.Fragment>
    </div>
  );
}